import { Select, Input } from "antd";
import NumberFormat from "react-number-format";
const { Option } = Select;

const SelectCurrencyInput = ({
  onChange,
  onChangeCurrency,
  defaultValue,
  label,
  id,
  value,
  disabled
}) => {
  const handleSelect = (e) => {
    onChangeCurrency(id, e);
  };

  const handleChange = (e) => {
    onChange(id, e, label);
  };

  return (
    <div>
      <p>{label}</p>
      <div className="d-flex">
        <NumberFormat
          disabled={disabled}
          value={value}
          isNumericString={true}
          onValueChange={handleChange}
          thousandSeparator={"."}
          decimalSeparator={","}
          style={{
            border: "0.75px solid #DCDCDC",
            width: "100%",
            paddingLeft: 6,
          }}
        />
        <Select
          onChange={handleSelect}
          defaultValue={defaultValue}
          className="select-after"
        >
          <Option value="percent">Persen</Option>
          <Option value="rupiah">Rupiah</Option>
        </Select>
      </div>
    </div>
  );
};

export default SelectCurrencyInput;
